import type { GetFeaturesInnerParams } from '@/app/components/search/components/EvolutionCard/Details/Features/getFeatures/types.ts';
import { type Feature } from '@/app/components/search/components/EvolutionCard/utils/facilitiesTypes.ts';

import {
  getFlexibleFeatures,
  getLiveSearchFeatures,
  getOpxFlexDates,
  getOvernightSearchFeatures,
  getPartialStaySearchFeatures,
} from '@/app/components/search/components/EvolutionCard/Details/Features/getFeatures/utils/getDateFeaturesUtils.tsx';

export const getDateFeatures = (params: GetFeaturesInnerParams): Feature[] => {
  const {
    datesText,
    isHO,
    isFlexible,
    isLiveSearch,
    isPartialStay,
    hasOpxFlexDates,
    isOvernight,
    hasApexFlexibleDates,
  } = params;
  const isHOLiveSearch = isHO && !isFlexible;

  if (isHOLiveSearch || !datesText) return []; // Handle non-flexible date scenarios
  if (isFlexible) return getFlexibleFeatures(params);
  if (isLiveSearch && isOvernight) return getOvernightSearchFeatures(params);
  if (isLiveSearch && isPartialStay) return getPartialStaySearchFeatures(params);
  // MPH-945: while the flexible-dates switcher is applied the whole list uses one date format, so the
  // OPX nearby-dates variant stands down.
  if (isLiveSearch && hasOpxFlexDates && !hasApexFlexibleDates) return getOpxFlexDates(params);
  if (isLiveSearch) return getLiveSearchFeatures(params);

  return [];
};
